module.exports = __webpack_public_path__ + "static/media/g5.50d0f17b.jpg";